import React from 'react';
import PropTypes from 'prop-types';
import { SelectBox } from 'devextreme-react';
import './select-box.scss';

export default function DefaultSelectBox(props) {
    const {
        displayStar,
        caption,
        displayValue,
        value,
        disabled,
        placeholder,
        onValueChanged,
        stylingMode = "outlined",
        items = [],
        direction = "vertical",
        labelWidth,
        isResetStyle,
        justify: _justify = "left",
        align: _align = "left",
        className,
        labelClassName,
        hideColon,
        readOnly,
        ...rest
    } = props;

    const justify = React.useMemo(() => `justify ${_justify}`, [_justify]);
    const align = React.useMemo(() => `align ${_align}`, [_align]);
    const resetStyle = React.useMemo(() => isResetStyle ? 'reset ' : '', [isResetStyle]);

    const sb_onChangeHandler = (event) => {
        onValueChanged?.(event.value)
    }

    return (
        <div className={`select-box-container ${className ?? ''} ${direction} ${justify} ${align}`}>
            <div className={`${resetStyle}dx-fieldset-text`} style={{ width: labelWidth }}>
                <div className="dx-field">
                    <div className="dx-field-label">
                        <span className={["label", labelClassName].join(" ")}>{caption}</span>
                        <>{displayStar ? (<span style={{ color: 'red' }}> * </span>) : ""}{!hideColon && ":"}</>
                        {displayValue === '' ? <span className="required-field">Required</span> : null}
                    </div>
                </div>
            </div>
            <div className={`${resetStyle}dx-fieldset field`}>
                <div className="dx-field">
                    <div className="dx-field-value">
                        <SelectBox
                            {...rest}
                            items={items}
                            className={disabled ? "select-box-disabled" : "select-box"}
                            value={value}
                            readOnly={readOnly}
                            disabled={disabled}
                            placeholder={placeholder}
                            onValueChanged={sb_onChangeHandler}
                            stylingMode={stylingMode}
                            autoResizeEnabled
                            maxHeight={80}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

DefaultSelectBox.propTypes = {
    displayStar: PropTypes.bool,
    caption: PropTypes.string,
    displayValue: PropTypes.string,
    value: PropTypes.string,
    disabled: PropTypes.bool,
    readOnly: PropTypes.bool,
    placeholder: PropTypes.string,
    stylingMode: PropTypes.oneOf(["outlined", "underlined", "filled"]),
    items: PropTypes.array,
    onValueChanged: PropTypes.func,
    direction: PropTypes.oneOf(["horizontal", "vertical"]),
    labelWidth: PropTypes.number,
    className: PropTypes.string,
    labelClassName: PropTypes.string,
    hideColon: PropTypes.bool,
}